import { PROMOS_REQUEST_ERROR } from '../../constants/notifications';
import { mapPromoOffersSelection } from '../../mappers';
import { IPromoQuerySchema } from '../../repositories/search-offers/entities/query_for_offer_promos/PromoQuerySchema';
import { fetchPromoOffersSafe } from '../../services/fetchPromoOffers/fetchPromoOffersSafe';
import { resolveSearchPromosPage } from '../../services/promosSearch';
import { TThunkAction } from '../../types/redux/thunk';
import { getLocationPath } from '../../utils/url';
import { trackNewPageAction } from '../analytics';
import { updateBrowserHistory } from '../browserHistory';
import { setError } from '../error';
import { setPromoOffers } from '../promoOffers';
import { promosFailure, promosRequest, promosSuccess } from '../promos/actions';

/**
 * Redux action, который запрашивает объявления с текущем состоянием nextJsonQuery
 */
export const promosRequestAction = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { logger, httpApi, custom } = context;

  const state = getState();
  const nextJsonQuery = state.nextJsonQuery;
  const subdomain = custom.subdomain;
  const path = getLocationPath();

  try {
    dispatch(promosRequest());

    const searchPromise = resolveSearchPromosPage({
      httpApi,
      logger,
      jsonQuery: nextJsonQuery,
      subdomain,
      path,
    });

    const promoOffersPromise = await fetchPromoOffersSafe(context, {
      query: nextJsonQuery as IPromoQuerySchema,
      subdomain,
    });

    const [newData, promoOffersResponse] = await Promise.all([searchPromise, promoOffersPromise]);

    dispatch(promosSuccess(newData));
    dispatch(setPromoOffers(mapPromoOffersSelection({ config: context.config, promoOffersResponse })));
    dispatch(updateBrowserHistory());
    dispatch(trackNewPageAction());
  } catch (e) {
    dispatch(promosFailure());

    dispatch(setError({ id: Date.now(), message: PROMOS_REQUEST_ERROR }));

    throw e;
  }
};
